import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function FiskalniCarinskiMenadzmentEJS() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Fiskalni i carinski menadžment" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Fiskalni i carinski menadžment</h2>
              <p>
                <strong>Studijski program:</strong> Ekonomija javnog sektora
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Fiskalni Menadžment
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet ima za cilj osposobljavanje studenata da razumiju
                osnovni fiskalni sistem kako u zemlji tako i na prostoru EU
                carinski sistem iz područja carinskog sistema carinskih politika
                koji su neophodni studentima fakulteta i zaposlenima javne
                administracije za obavljanje poslova iz oblasti
                spoljnotrgovinskog poslovanja (carine međunarodne špedicije i
                dr.). Upoznavanje i razumijevanje složene prirode poreskih i
                carinskih institucija poreskog i carinskog sistema i poreske i
                carinske politike na čijoj upotrebi se zasniva finansijska
                djelatnost javnog pravnog tijela; ovladavanje konceptom
                iskustvima i teorijskim pristupima poreskog i carinskog sistema
                i politike (Domicilna poreska i carinska struktura i poreske i
                carinske strukture zemalja Evropske unije). Studenti se
                obučavaju u okviru ovog predmeta da mogu uspješno i odgovorno
                primjenjivati u praksi institute instrumente i mjere carinskog i
                poreskog sistema u zaštiti domaće proizvodnje od spoljne
                konkurencije fiskalne i bezbjednosne funkcije države.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Teorijska praktična i aplikativna znanja i vještine iz oblasti
                koje su obuhvaćene studijskim programom Menadžment javnog
                sektora. Studenti su osposobljeni da shvate carinski i poreski
                sistem spoljnotrgovinski devizni sistem koji su u nadležnosti
                carinskih i poreskih organa.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Osnovne karakteristika predmeta Fiskalni
                menadžment. Definisanje i značenja koncepta Fiskalnog
                menadžmenta. Opis poreskih i carinskih elemenata. Zatim se daje
                model opšte definicije carinskog sistema primjenom sistemskog
                pristupa sa sadržajnim elementima procesnog modela carinskog
                sistema. Detaljnu analizu pojedinih vrsta poreskih i carinskih
                oblika. Komparativni pregled važećih poreskih i carinskih
                rješenja. Osnove poreske i carinske politike. Analiza
                makroekonomskog dejstva poreske i carinske politike.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja se održavaju prema utvrđenom rasporedu uz korišćenje
                savremenih prezentacionih i demonstracionih sredstava i tehnika
                sa primjenom interaktivne metode rada sa studentima čime se
                stiče uvid u njihova predznanja i specifična iskustva zasnovana
                na obrađivanoj problematici ali i uvid u kontiuitet savladavanja
                gradiva. Korišćenje edukativnih sadržaja u elektronskoj i
                digitalnoj formi (koji uključuju i snimljena predavanja i
                mentorske vježbe) na različitim video prezentacionim medijima.
                Vježbe su namjenjene za sticanje praktičnih vještina i
                elaboriranje praktičnih aspekata osnovnih tema. Vježbe sadržajem
                prate tematske jedinice predavanja. Kao specifični oblici vježbi
                primjenjuju se repetitoriji gdje saradnici u nastavi (asistenti
                demonstratori) pripremaju studente za polaganje ispita nudeći im
                koncizni pregled glavnih tačaka određenog predmeta.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Pojam i razvoj javnih prihoda, klasifikacija javnih
                      prihoda, pojam javnih rashoda, podjela javnih rashoda
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Načela javnih rashoda, pokriće javnih rashoda, efekti
                      javnih rashoda, obim javnih rashoda
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>Pojam poreza, istorijski razvoj poreza</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>Klasifikacija poreza</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Poreska stopa - pojam i vrste poreza, poreskih stopa,
                      pojam poreskih olakšica
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P + 2V</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Utvrđivanje poreza, problemi i značaj naplate poreza
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Inspekcijski nadzor i carinska politika</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Osnovne karakteristike najznačajnijih carinskih postupaka
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>
                      Nadležnost, organizacija i funkcionisanje uprava carina
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>Osnovne karakteristike carinske službe Crne Gore</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P + 2V</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Smjernice za reformu carinskog sistema Crne Gore u procesu
                      integracija u Evropsku uniju
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>Smjernice svjetske carinske organizacije</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Upravljanje rizikom u procesu reformi carinskog sistema
                      Crne Gore - Preporuke svjetske banke
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FiskalniCarinskiMenadzmentEJS;
